/* istanbul ignore file */
import { array as codecArray, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AddUsersSectionDataParser = /* #__PURE__ */ parsers.object([['userIds', /* #__PURE__ */ codecArray(codecNumber), 'user_ids']]);
export class AddUsersSectionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AddUsersSectionDataParser.decode(input).map(res => new AddUsersSectionData(res));
    }
    static unsafeDecode(input) {
        return AddUsersSectionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AddUsersSectionDataParser.encode(data);
    }
    static schema() {
        return AddUsersSectionDataParser.schema();
    }
}
